<template>
  <div class="about">

    <div class="titles wrapper">
      <h3 class="titles__subtitle">About me</h3>
      <p class="titles__title">Currently a UX designer at <a href="http://spintank.fr" target="_blank">Spintank</a>, I graduated from a tech entrepreneurship master's degree at HETIC, Paris.</p>
      <p class="titles__title">I am obsessed by the democratic, environmental and social challenges humanity is facing. </p>
      <p class="titles__title">I want to design products that help build a more caring, durable and well-informed society.</p>
    </div>

    <div class="windowsCanvas wrapper">

      <div class="window windowsCanvas__item">
        <div class="window__container">
          <div class="window__container__title"><h4>Experience</h4></div>
          <div class="window__container__content">
            <ul>
              <li>2020 — UX designer at media agency <a href="http://spintank.fr" target="_blank">Spintank</a></li>
              <li>2019 — Design and consulting intern at <a href="https://tangity.design" target="_blank">Tangity</a> (NTT DATA UK)</li>
              <li>2018 — Product design intern on an IoT health app at <a href="http://withings.com" target="_blank">Withings</a></li>
              <li>2017 — Creative development intern at media agency <a href="http://datagif.fr" target="_blank">Datagif</a></li>
              <li>2016 — Interactive data-visualizations freelance for <strong>Mars Group</strong></li>
            </ul>
          </div>
        </div>
      </div>

      <div class="window windowsCanvas__item">
        <div class="window__container">
          <div class="window__container__title"><h4>Skills</h4></div>
          <div class="window__container__content">
            <ul>
              <li><strong>User experience design</strong></li>
              <li><strong>User research and testing</strong></li>
              <li><strong>Workshops and co-design</strong></li>
              <li><strong>Digital ecosystems strategy</strong></li>
              <li>UI and motion design</li>
              <li>Front-end web development</li>
              <li>Digital marketing and business models</li>
              <li>Annoying out-of-scope question asking</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="window windowsCanvas__item">
        <div class="window__container">
          <div class="window__container__title"><h4>More me</h4></div>
          <div class="window__container__content">
            <ul>
              <li>👔 <a href="http://linkedin.com/in/NoeFalque" target="_blank" title="Linkedin">Linkedin</a> : <s>motivational quotes</s> a few news</li>
              <li>📰 <a href="http://medium.com/@NoeFalque" target="_blank" title="Medium">Medium</a> (in 🇫🇷) : thoughts about media</li>
            </ul>
          </div>
        </div>
      </div>

    </div>

    <contact theme="black"/>

    <footer class="wrapper faded">
      <p class="left">Design, dev and ©: Noé Falque, 2019 </p>
      <p class="right">Fonts by <a href="https://rsms.me/inter/">Rasmus Andersson</a> and <a href="https://www.renebieder.com/retail-fonts/galano">Rene Bieder</a></p>
    </footer>

  </div>
</template>

<script>

import Contact from '@/components/_Contact.vue';

export default {
  name: 'About',
  components: {
    Contact
  },
  created() {
    /** Change page theme:  */
    const styles = document.styleSheets[0];
    styles.addRule('body', `color: white;`);
    styles.addRule('body', `background: black;`);
    styles.addRule('.header', `color: white;`);
    styles.addRule('.header .btn', `background: black;`);
    styles.addRule('.header .btn::before', `background: lime;`);
  }
}

</script>

<style lang="scss">

// body {
//   background: black;
//   color: white;
// }

// .header {
//   color: white;

//   .btn {
//     background: black;

//     &::before {
//       background: lime;
//     }
//   }
// }

.about {
  padding-top: 160px;
}

</style>



// WEBPACK FOOTER //
// src/components/About.vue